module.exports = __webpack_public_path__ + "media/images/emblems/Vitznau_LU-c4ba41de0f304d81b0278d52993476b1.png";